class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;
    this.closeTimer = null;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this)
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute("open")) {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.animations.forEach((animation) => animation.play());
    } else {
      // 增加到3秒延迟，给用户更多时间移动到子菜单
      this.closeTimer = setTimeout(() => {
        this.animations.forEach((animation) => animation.cancel());
        this.closeTimer = null;
      }, 3000);
    }
  }

  close() {
    // 关闭时也增加到3秒延迟
    setTimeout(() => {
      this.mainDetailsToggle.removeAttribute("open");
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
    }, 3000);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");
    this.hoverTimeout = null;
    this.setupHoverEvents();
  }

  setupHoverEvents() {
    // 为菜单项添加鼠标事件
    const menuItems = this.querySelectorAll(".list-menu__item");
    const details = this.querySelector("details");

    if (!details) return;

    // 鼠标进入菜单项
    this.addEventListener("mouseenter", () => {
      if (this.hoverTimeout) {
        clearTimeout(this.hoverTimeout);
        this.hoverTimeout = null;
      }
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
    });

    // 鼠标离开菜单项
    this.addEventListener("mouseleave", () => {
      this.hoverTimeout = setTimeout(() => {
        if (details.hasAttribute("open")) {
          details.removeAttribute("open");
          const summary = details.querySelector("summary");
          if (summary) {
            summary.setAttribute("aria-expanded", "false");
          }
        }
      }, 500); // 500ms延迟，给用户时间移动到子菜单
    });

    // 为子菜单添加鼠标事件
    const subMenu = details.querySelector(".list-menu");
    if (subMenu) {
      subMenu.addEventListener("mouseenter", () => {
        if (this.hoverTimeout) {
          clearTimeout(this.hoverTimeout);
          this.hoverTimeout = null;
        }
      });

      subMenu.addEventListener("mouseleave", () => {
        this.hoverTimeout = setTimeout(() => {
          if (details.hasAttribute("open")) {
            details.removeAttribute("open");
            const summary = details.querySelector("summary");
            if (summary) {
              summary.setAttribute("aria-expanded", "false");
            }
          }
        }, 300);
      });
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop"
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define("header-menu", HeaderMenu);
